export const CompleteSignUp = {
  title: 'Complete Sign Up',
  email: 'Email',
  birthdate: 'Birth Date',
  phone: 'Mobile Phone',
  nickname: 'Nickname',
  complete: 'Complete'
};
